import { z } from "zod";

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

export const accountStepFormSchema = z
  .object({
    name: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    birthdate: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    email: z
      .string({ message: "Obrigatório" })
      .min(1, "Obrigatório")
      .email("E-mail inválido"),
    phone: z.string({ message: "Obrigatório" }).min(1, "Obrigatório"),
    cpfCnpj: z
      .string({ message: "Obrigatório" })
      .min(11, "Mínimo de 11 dígitos"),
    rg: z.string({ message: "Obrigatório" }).min(9, "Mínimo de 9 dígitos"),
    stateRegistration: z
      .string({ message: "Obrigatório" })
      .min(1, "Obrigatório"),
    password: z
      .string({ message: "Obrigatório" })
      .min(8, "A senha deve possuir ao menos 8 caracteres")
      .refine((value) => passwordRegex.test(value), {
        message:
          "A senha deve conter pelo menos 1 letra maiúscula, 1 letra minúscula, 1 número e 1 caractere especial",
      }),
    confirmPassword: z
      .string({ message: "Obrigatório" })
      .min(8, "A senha deve possuir ao menos 8 caracteres"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "As senhas não conferem.",
    path: ["confirmPassword"],
  });

export type AccountStepFormValues = z.infer<typeof accountStepFormSchema>;
